import React, {useState} from 'react';
import UsersList from "./UsersList";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PermissionLevels from './PermissionLevels';

export default function Users() {
  const [selectedTab, setSelectedTab] = useState('app');

  return (
    <div>
      <div style={{borderBottom: '1px solid #ccc', marginBottom: '1rem'}}>
        <Tabs
          value={selectedTab}
          onChange={(event, value) => setSelectedTab(value)}
          indicatorColor="primary"
          textColor="primary"
          aria-label="User account types"
        >
          <Tab label="App Accounts" value="app" />
          <Tab label="Kite Guest Accounts" value="kite" />
          <Tab label="Permission Levels" value="permissions" />
        </Tabs>
      </div>

      {selectedTab === 'app' && (
        <UsersList
          accountType="app"
          heading="App Accounts"
          roleFilter={{role: {$ne: 'guest'}}}
        />
      )}
      {selectedTab === 'kite' && (
        <UsersList
          accountType="kite"
          heading="Kite Accounts"
          roleFilter={{role: 'guest'}}
          allowCreate={false}
          allowInvite={false}
        />
      )}
      {selectedTab === 'permissions' && <PermissionLevels />}
    </div>
  );
}
